import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { SharedProviderModule } from '../shared/shared.module';
import { VrgroupModule } from '../custom/vrgroup/vrgroup.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { UptimeComponent } from './uptime/uptime.component';
import { UptimeService } from './uptime/uptime.service';
import { MessagesComponent } from './messages/messages.component';

@NgModule({
  imports: [
    SharedProviderModule,
    VrgroupModule,
    NgxChartsModule,
  ],
  providers: [
    UptimeService
  ],
  declarations: [DashboardComponent, UptimeComponent, MessagesComponent],
  exports: [DashboardComponent]
})
export class DashboardModule {
}
